import { Editor } from '@tiptap/core';
import StarterKit from '@tiptap/starter-kit';

document.addEventListener('alpine:init', () => {
    Alpine.data('editor', (content) => {
        let editor; // Alpine's reactive engine automatically wraps component properties in proxy objects. Attempting to use a proxied editor instance to apply a transaction will cause a "Range Error: Applying a mismatched transaction", so be sure to unwrap it using Alpine.raw(), or simply avoid storing your editor as a component property, as shown in this example.

        return {
            updatedAt: Date.now(), // force Alpine to rerender on selection change
            init() {
                const _this = this;

                editor = new Editor({
                    element: this.$refs.element,
                    extensions: [
                        StarterKit,
                    ],
                    content: content,
                    onCreate({editor}) {
                        _this.updatedAt = Date.now();
                    },
                    onUpdate({editor}) {
                        _this.updatedAt = Date.now();
                    },
                    onSelectionUpdate({editor}) {
                        _this.updatedAt = Date.now();
                    },
                });
            },
            isLoaded() {
                return editor;
            },
            isActive(type, opts = {}) {
                return editor.isActive(type, opts);
            },
            setParagraph(opts) {
                editor.chain().setParagraph(opts).focus().run();
            },
            toggleHeading(opts) {
                editor.chain().toggleHeading(opts).focus().run();
            },
            toggleBold() {
                editor.chain().toggleBold().focus().run();
            },
            toggleItalic() {
                editor.chain().toggleItalic().focus().run();
            },
            toggleBulletList() {
                editor.chain().toggleBulletList().focus().run();
            },
            toggleOrderedList() {
                editor.chain().toggleOrderedList().focus().run();
            },
        };
    });
});
